module.exports = __webpack_public_path__ + "static/media/eclipse.f8185763.svg";